// i18n ignore
import pageLoader from '@/loaders/page/loader';
import { useRouter } from '@/router/useRouter';
import { safeAsync } from './types';
function escapeSingleQuotedUnionMember(id) {
    const s = String(id)
        .replace(/\\/g, '\\\\')
        .replace(/'/g, '\\\'');
    return `'${s}'`;
}
/**
 * 生成全局弹窗 useGlobalModal 的类型定义（仅在存在弹窗页面时注入）
 */
function generateGlobalModalDts(modalPages) {
    const sorted = [...modalPages].sort((a, b) => a.pageId.localeCompare(b.pageId));
    const idUnion = sorted.map(p => escapeSingleQuotedUnionMember(p.pageId)).join(' | ');
    const idLines = sorted.map((p) => {
        const label = p.name?.trim() ? p.name.trim() : p.pageId;
        return `   * - \`${p.pageId}\` ${label}`;
    }).join('\n');
    const firstId = sorted[0]?.pageId ?? '';
    return `
  /**
   * 全局弹窗（页面类型为弹窗；仅当应用内已配置弹窗页面时注入）
   *
   * 已配置的弹窗 pageId：
${idLines}
   * @example
   * \`\`\`typescript
   * const { open, hide } = useGlobalModal();
   * await open(${escapeSingleQuotedUnionMember(firstId)}, { foo: 1 });
   * hide('${firstId}_suffix', { result: true });
   * \`\`\`
   */
  export function useGlobalModal(): {
    /**
     * 打开全局弹窗（对应 showGlobalModal）
     */
    open(
      id: ${idUnion},
      data?: any,
      opt?: { keepAlive?: boolean; suffix?: string },
    ): Promise<any>;
    /**
     * 关闭全局弹窗（对应 hideGlobalModal；id 可为 pageId 或 pageId_suffix）
     */
    hide(id: string, data?: any, opt?: { destroy?: boolean }): void;
  };`;
}
/**
 * 全局弹窗 DTS 注入器：仅当 basic 页面列表中存在 pageType 为 modal 的页面时注入
 */
export const globalModalInjector = {
    placeholder: '/** inject-global-modal-dts */',
    async generate(projectId) {
        const { route } = useRouter();
        const branchId = String(route.value?.query?.branch || route.value?.query?.branchid || '');
        const list = await safeAsync(() => pageLoader.loadBasicList(projectId, { query: { filter: 'pageType="modal"', size: 'total' } }, 'dev', branchId || undefined), [], '获取弹窗页面列表失败');
        const modalPages = (Array.isArray(list) ? list : []).filter((p) => !!p && p.pageType === 'modal');
        if (!modalPages.length) {
            return '';
        }
        const brief = modalPages.map(p => ({
            pageId: p.pageId,
            name: p.name || '',
        }));
        return generateGlobalModalDts(brief);
    },
};
export { generateGlobalModalDts };
